import { Controller } from "@hotwired/stimulus";

// Utilisation :
// <div data-controller="toast"></div>
// Stimulus.dispatch("toast", { detail: { message: "Copié !" } })

export default class ToastController extends Controller {
  static instance;

  connect() {
    ToastController.instance = this;
    window.showToast = this.show.bind(this); // Optionnel : accès global
  }

  show({ detail }) {
    const message = detail?.message || "Action effectuée !";
    const toast = document.createElement("div");
    toast.className = "fixed bottom-6 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-4 py-2 rounded shadow-lg z-50 animate-fade-in-out";
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.classList.add("opacity-0");
      setTimeout(() => toast.remove(), 300);
    }, 1200);
  }
}

// Animation CSS à ajouter dans ton CSS :
// .animate-fade-in-out { transition: opacity 0.3s; opacity: 1; }
// .opacity-0 { opacity: 0; } 